import { IsNumber, IsString } from "class-validator";
import { Expose } from "class-transformer";

export class IntegrationConfigurationListItem {
  @Expose()
  @IsNumber()
  key!: number;
  @Expose()
  @IsString()
  value!: string;
}
